import { FIELD_IS_VALID } from '../../../Constants';

const isCreator = (creator) => {
  if (typeof creator === 'string') {
    return creator.trim().length > 0;
  }

  return Boolean(creator && (creator.userName || creator.displayName));
};

const creatorValidation = (creators) => {
  const hasCreator = Array.isArray(creators) && creators.some(isCreator);

  if (!hasCreator) {
    return 'collection_validation_creator_is_required';
  }

  return FIELD_IS_VALID;
};

export default creatorValidation;